import DragScroll from "components/common/DragScroll";

const ProductAllergens = ({
  allergens = [],
  showAllergens,
  allergenBackgroundColor,
}) => {
  if (!showAllergens || allergens.length === 0) return null;

  return (
    <div
      className="allergens allergens_div"
      style={{ maxWidth: "100%", width: "100%" }}
    >
      <DragScroll className="inner_section allergen_inner" style={{maxWidth:270}}>
        {allergens.map((allergen, idx) => (
          <div
            key={idx}
            className="inner_div"
            style={{
              "--theme-primary-color": allergenBackgroundColor,
            }}
          >
            <img
              src={allergen.url}
              width={15}
              height={15}
              alt=""
            />
          </div>
        ))}
      </DragScroll>
    </div>
  );
};

export default ProductAllergens;
